import { render, staticRenderFns } from "./UrlCensus.vue?vue&type=template&id=1f42361f&scoped=true"
import script from "./UrlCensus.vue?vue&type=script&lang=js"
export * from "./UrlCensus.vue?vue&type=script&lang=js"
import style0 from "./UrlCensus.vue?vue&type=style&index=0&id=1f42361f&prod&lang=scss"
import style1 from "./UrlCensus.vue?vue&type=style&index=1&id=1f42361f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f42361f",
  null
  
)

export default component.exports